import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';

const SuspenseFallback = () => (
  <Box alignItems="center" justifyContent="center" height={300}>
    <Loader size={50} />
  </Box>
);

export default SuspenseFallback;
